import { render, staticRenderFns } from "./CreateUpdatePartnerOffer.vue?vue&type=template&id=2fbe11b1&scoped=true"
import script from "./CreateUpdatePartnerOffer.vue?vue&type=script&lang=ts"
export * from "./CreateUpdatePartnerOffer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe11b1",
  null
  
)

export default component.exports